import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const serviceAreas = [
  {
    name: "Northern Beaches",
    href: "/northern-beaches",
    description:
      "Strong weekend demand near Manly, Dee Why and Palm Beach with suburb-level pricing and turnover operations.",
  },
  {
    name: "Lower North Shore",
    href: "/lower-north-shore",
    description:
      "Premium apartments in Mosman and Neutral Bay with strata-aware processes and executive-stay positioning.",
  },
  {
    name: "North Shore",
    href: "/north-shore",
    description:
      "Family and executive homes managed with compliance-first onboarding, maintenance triage, and quality controls.",
  },
  {
    name: "Eastern Suburbs",
    href: "/bondi",
    description:
      "Bondi, Bronte and Coogee listings optimized for high ADR windows and seasonality-driven occupancy swings.",
  },
  {
    name: "Sydney CBD",
    href: "/sydney-cbd",
    description:
      "Executive apartment management built for corporate, relocation, and high-turnover city-stay demand cycles.",
  },
  {
    name: "Inner Sydney",
    href: "/inner-sydney",
    description:
      "Inner-city portfolio operations with demand-based stay rules, faster response SLAs, and review protection.",
  },
];

const LocationCoverage = () => {
  return (
    <section className="py-12 sm:py-16 bg-white border-y border-border">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-10">
          <p className="inline-flex items-center rounded-full bg-foreground/5 px-4 py-2 text-xs sm:text-sm font-semibold uppercase tracking-[0.16em] text-foreground mb-4">
            Service Areas
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-foreground leading-[1.08] mb-4">
            Servicing Sydney&apos;s Most Sought-After Locations
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {serviceAreas.map((area, index) => (
            <motion.article
              key={area.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              className="rounded-2xl border border-border bg-[#F8FAFC] p-5 sm:p-6"
            >
              <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-3">
                <MapPin className="h-3.5 w-3.5" />
                Sydney
              </p>
              <h3 className="font-serif text-2xl text-foreground mb-2">{area.name}</h3>
              <p className="text-sm text-muted-foreground mb-5">
                {area.description}
              </p>
              <Link
                to={area.href}
                className="inline-flex items-center gap-2 text-sm font-semibold text-foreground hover:text-secondary"
              >
                View {area.name}
                <ArrowRight className="h-4 w-4" />
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationCoverage;
